import React from 'react';
import Pagination from '../../Pagination';
import { IPaginationStripProps } from '../../../Pagination.types';
import PageStrip from './PageStrip';

const PaginationStrip: React.FC<IPaginationStripProps> = props => {
  return (
    <Pagination {...props}>
      {({ onChange }) => (
        <PageStrip key={props.currentPage} {...props} onChange={onChange} />
      )}
    </Pagination>
  );
};

export default PaginationStrip;
